// HIPAY paypal button style

window.paypalButtonStyle = {
    layout: 'vertical',
    color: 'white',
    shape: 'pill',
    label: 'paypal',
    tagline: false
};

function custom_paypal_hipay() {
    // overrides app function that added a loader to an element other than the paypal button
}

// Function used on quantity selector evolution
function updateProductQuantity(action, prod_id) {
    var qte_stock,
        qte_input,
        plus_selector,
        minus_selector;
    var is_wishlist = $('#wishlist').length > 0;

    // Recover html selectors
    plus_selector = $("#ligne_qte .qte_plus");
    minus_selector = $("#ligne_qte .qte_minus");

    // Get product stock quantity and input quantity selected values
    qte_stock = $('#product_stock_counter').val();
    qte_stock = (qte_stock != '') ? qte_stock : 0;
    qte_input = $('#ligne_qte .qte_selected').val();
    qte_input = (qte_input != '') ? qte_input : 0;

    if (action == 'plus') {
        qte_input++;

        // Remove disabled classes if necessary
        if ((qte_input > 1) && (minus_selector.hasClass('selector_disabled'))) {
            minus_selector.removeClass('selector_disabled');
        }

        // Update form
        if (qte_input <= qte_stock) {
            $('#qteProd').val(qte_input);
        } else {
            qte_input--;
            plus_selector.addClass('selector_disabled')
        }

    } else if (action == 'minus') {
        qte_input--;

        // If qte stored in input can be decremented
        if ((qte_input > 1) || (qte_input == 1)) {
            $('#qteProd').val(qte_input);
        }

        // add diabled class if needed
        if (qte_input == 1) {
            if (!minus_selector.hasClass('selector_disabled')) {
                minus_selector.addClass('selector_disabled');
            }
        }
    }

    // Update input holding stock counter to add security : if qte = 0 you can't add it to your cart
    getAvailableQuantity(prod_id, qte_input, 'product', '', is_wishlist);
}

function seeAllDescription() {
    // Gestion d'ouverture de l'onglet description et fermeture des autres onglets
    if (!$("#description_longue").hasClass("actif")) {
        $(".product_detail").removeClass("actif");
        $(".product_detail_content").hide();
        $("#description_longue").addClass("actif");
        $("#description_longue .product_detail_content").slideDown();
    }

    // Récupération de l'emplacement de l'onglet description et gestion de l'offset en fonction du menu et du preheader
    var offset = ($("#description_longue")).offset();
    var offsetPreheader;
    var offsetMenu;

    if ($("#site_head_wrap").hasClass("bandeau_on")) {
        offsetPreheader = $("#header_mention_id").height();
    } else {
        offsetPreheader = 0;
    }

    offsetMenu = $("#top_wrapper").height();

    var offsetTop = offset.top - offsetMenu - offsetPreheader - 20;

    // Scroll vers l'onglet description
    setTimeout(function () {
        $("html, body").animate({
            scrollTop: offsetTop
        }, 200);
    }, 250);
}

// Called upon size change in product page
function onItemSizeChange(form, is_regroup, itm_rr_id, change_size = true) {

    var control;
    var isWishList = $('#wishlist').length > 0;
    var isAchatExpressV2 = ($('#is_achat_express_v2').val() == 1 && !isWishList);
    var productId = form.getValue('produit_id');
    var productRef = form.getValue('produit_ref');
    control = form.elements.namedItem('tailleProd');
    control.value = this.value.trim();
    var from = ($('#is_from_lookbook').val() !== undefined) ? 'lookbook' : 'product';
    itm_rr_id = itm_rr_id !== undefined ? itm_rr_id : '';

    if (isAchatExpressV2) {
        if (this.checked) {

            if ($('#sizeerror').is(':visible')) {
                $('#sizeerror').slideUp();
            }

            loadProduct.call(form, productId, 'taille', from, itm_rr_id, 'sizeChange');

            // Depending on the color we see if the product is available, do this only in product page
            // We check if the product is already in the wishlist
            checkProductInWishlist(productId, productRef, true);
        }
    } else {

        if ($('#sizeerror').is(':visible')) {
            $('#sizeerror').slideUp();
        }
        if (is_regroup) {
            loadProduct.call(form, productId, 'taille', from, itm_rr_id, 'sizeChange');
        }
    }

    if (change_size && window.dataLayer !== undefined) {
        pushToWshopBus({
            'event': 'changeSize',
            'produit': {
                'size_value': ($(this).attr('data-nom')),
            }
        });
        if (window.dataLayer[0].product) {
            window.dataLayer[0].product.size = ($(this).attr('data-nom'));
        }
    }
}

// Pretty straightforward: this formats a price
var formatPrice = (function () {
    var THREEDIGITS = new RegExp("\\d{3}", "g");
    var FORMAT = window.price_format_plain;

    // Splits a number into chunks of 3 digits
    function splitThousands(nmbr) {
        var f_chunk = "",
            chunk_length;

        nmbr = String(nmbr);
        chunk_length = nmbr.length % 3;

        if (chunk_length) {
            f_chunk = nmbr.slice(0, chunk_length);
            nmbr = nmbr.substr(chunk_length);
        }

        return (
            f_chunk +
            nmbr.replace(THREEDIGITS, function (match) {
                return " " + match;
            })
        );
    }

    return function (price) {
        var CURRENCY = window.siteCurrency;
        var output;

        if (price.constructor !== String) {
            price = price.toString(10);
        }

        price = price.replace(".", ",");
        price = price.split(",");

        if (price[1] === undefined) {
            price[1] = '00';
        } else if (price[1].length == 1) {
            price[1] = price[1] + '0';
        }
        output = FORMAT.replace("[<unit>]", splitThousands(price[0]));
        output = output.replace("[<symbol_right>]", CURRENCY.symbol_right);
        output = output.replace("[<symbol_left>]", CURRENCY.symbol_left);
        output = output.replace("[<decimal>]", price[1]);
        output = output.replace("[<code>]", CURRENCY.code);

        return output;
    };
})();

/**
 * Filter orders by type
 */
function show_orders_by_type(elementID, type, parentPath, reload) {

    var str_year = '';
    var str_reload = '';
    var year = $("#year").val();

    if (year != '') {

        str_year = '&year=' + year;
    }

    if (reload !== undefined) {

        str_reload = '&reload=true';
    }

    // Gestion de la surbrillance des onglets
    var i = 1;
    while (document.getElementById("com_onglet_" + i)) {

        if (type == i) {

            $("#com_onglet_" + i).addClass("actif");
        } else {

            $("#com_onglet_" + i).removeClass("actif");
        }
        i++;
    }

    var container = document.getElementById(elementID);

    if (container) {

        var response = ajax_file(parentPath + create_link('ajax_account_orders_by_type') + '?type=' + type + str_year + str_reload);
        if (response) {

            if (reload !== undefined) {

                $('.content_commandes').html(response);
            } else {

                $(container).html(response);
            }
        } else {

            container.innerHTML = '';
        }
    }
}

/**
 * Change cart product quantity
 */
function changeQte(type) {

    var types = ['plus', 'less'],
        item, loader, qtty, ajax_url;

    if (types.includes(type)) {

        item = this.getValue('item_id', parseFloat);
        loader = document.getElementById('qte_loader_' + item);
        qtty = this.getValue('selected_qte', parseFloat);

        $(this).find('.selector .qteWrapper_bot').hide();
        loader.style.display = 'block';

        switch (type) {

            case 'plus':
                qtty += 1;
                break;

            case 'less':
                qtty -= 1;
                break;
        }

        $.ajax({
            url: path_relative_root + create_link('order_basket'),
            type: 'post',
            data: {
                action: 'del',
                panierId: item,
                cad: 'non',
                pointcad: 0,
                qteProd: qtty,
                change_qte: true
            },
            cache: false,
            success: function (res) {

                try {

                    res = JSON.parse(res);
                } catch (e) {

                    console.error('JSON ERROR: could not parse data');

                    return false;
                }

                resHtml = $('<div />').html(res.datas);

                document.getElementById('main_cart_wrapper').innerHTML = $('#main_cart_wrapper', resHtml).html();

                wShop.$refs.wCouponForm.reloadBloc += 1;
                //update top cart
                var response = ajax_file(create_link('ajax_show_basket'));

                cart = Translator.translate('mon_panier');

                document.getElementById('cart_top').innerHTML = response;

                var total = $('#cart_top .itm_menu').attr('data-cart'),
                    text;

                if (total <= 1) {
                    text = Translator.translate('one_product');
                } else {
                    text = Translator.translate('2_product');
                }

                $('.cart_main_title.basket').html(cart + ' ' + '<span class="nb_products">(' + total + ' ' + text + ')</span>');

                if (res.error_message.length) {
                    $('#modboxpromo').find('.texte').html(res.error_message);
                    openMultiShad('modboxpromo');
                }

            },
            complete: function () {
                dragDropWishlist();
                updateCartElements();
            }
        });
    }
}

function updateCartElements() {
    /* init swiper panier */
    if ($('body.step_1 .wrapperCartAssociations').length) {
        var swiperAssociations = new Swiper('.wrapperCartAssociations #cartAssociations', {
            roundLengths: true,
            setWrapperSize: true,
            slidesPerView: "auto",
            spaceBetween: 30,
            navigation: {
                nextEl: '.assoc-button-next.slide_next',
                prevEl: '.assoc-button-prev.slide_prev',
            },
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        });
    }

    /* Scrollbar Listes des Produits Panier */
    $(".top_basket_wrapper").overlayScrollbars({
        scrollbars: {
            autoHide: "leave",
            autoHideDelay: 0,
        }
    });

    getWishlistProducts();
}

function getWishlistProducts() {
    let array_elements = document.querySelectorAll('a[data-productid]');

    let array_ids = [];
    if (typeof array_elements != 'undefined' && array_elements.length > 0) {
        for (el of array_elements) {
            var id = el.getAttribute('data-productid');

            if (id !== '' && id !== 'undefined') {
                array_ids.push(id);
            }
        }
        let data = JSON.parse((JSON.stringify(Object.assign({}, array_ids))));

        $.ajax({
            type: 'get',
            url: path_relative_root + create_link('get_user_all_wishlist'),
            data: data,
            success: function (response) {
                if (response) {
                    if (typeof response != 'undefined' && response.length > 0) {
                        let array_product_id = JSON.parse(response);
                        for (product_wishlist in array_product_id) {
                            $('a[id = "addToWishlistButton_' + array_product_id[product_wishlist].fk_produit_id + '"]').addClass("full_heart");
                        }
                    }
                }
            }
        });
    }
}

$(function () {
    /* ________ HOME ________*/

    if ($('#coverSwiper').length) {
        new Swiper('#coverSwiper.swiper', {
            roundLengths: true,
            setWrapperSize: true,
            slidesPerView: 1,
            autoplay: true,
            loop: true,
            speed: 3000,
            pagination: {
                el: '#coverSwiper .swiper-pagination',
            },
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        })
    }
    
    $('body').on('mouseenter touchstart', '#swiperTg', function() {
        if ($('#swiperTg').length && !$('#swiperTg').hasClass('swiper-initialized')) {
            swiperTG();
        }
    });

    $('body').on('mouseenter touchstart', '#coverSwiper', function() {
        if ($('#coverSwiper').length && !$('#coverSwiper').hasClass('swiper-initialized')) {
            if ($('#coverSwiper').length) {
                new Swiper('#coverSwiper.swiper', {
                    roundLengths: true,
                    setWrapperSize: true,
                    slidesPerView: 1,
                    autoplay: true,
                    loop: true,
                    speed: 3000,
                    pagination: {
                        el: '#coverSwiper .swiper-pagination',
                    },
                    on: {
                        init: function () {
                            decodeVisibleSlides(this);
                        },
                        slideChange: function () {
                            decodeVisibleSlides(this);
                        }
                    }
                })
            }
        }
    });

    if ($('.home-module.blog-module').length) {
        new Swiper('.home-module.blog-module .swiper', {
            roundLengths: true,
            setWrapperSize: true,
            cssWidthAndHeight: true,
            slidesPerView: 1.6,
            visibilityFullFit: true,
            autoResize: false,
            spaceBetween: 30,
            breakpoints: {
                1690: {
                    slidesPerView: 3,
                },
                1440: {
                    slidesPerView: 2.6,
                },
                1300: {
                    slidesPerView: 2.4,
                },
                1160: {
                    slidesPerView: 2.2,
                },
                1030: {
                    slidesPerView: 2,
                },
            },
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        })
    }

    if ($('.home-module.image-image').length) {
        new Swiper('.home-module.image-image', {
            roundLengths: true,
            setWrapperSize: true,
            slidesPerView: 1.5,
            spaceBetween: 20,
            breakpoints: {
                1300: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
            },
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        })
    }

    /**
     * Product net reviews
     */
    if ($('.swiperNetreviews').length) {

        var swiperNetreviews = new Swiper('.swiperNetreviews.swiper', {

            slidesPerView: 2.2,
            roundLengths: true,
            setWrapperSize: true,
            spaceBetween: 30,
            navigation: {
                nextEl: '.netreviews-button-next',
                prevEl: '.netreviews-button-prev',
            },
            scrollbar: {
                el: ".swiperNetreviews .swiper-scrollbar",
                draggable: true,
            },
        });
    }

    /** PAGES ADV **/
    /* tg swiper */
    if ($('.tgCms').length) {
        new Swiper('.tgCms.swiper', {

            roundLengths: true,
            setWrapperSize: true,
            slidesPerView: 2.6,
            spaceBetween: 30,

            breakpoints: {
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1550: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
            navigation: {
                nextEl: '.tg-module .cmstg-button-next',
                prevEl: '.tg-module .cmstg-button-prev',
            },
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        })
    }

    /*Sets Module TITRE + IMAGE above breadcrumbs*/
    if ($(".cms_page .cms-page-module.image-text-1").length) {
        $("#cms_page_ariane, #cms_page_btn_back").insertAfter($(".cms-page-module.image-text-1"));
        $(".cms_page #cms_page_ariane").css("display", "flex");
    } else {
        $(".cms_page #cms_page_ariane").css("display", "flex");
    }

    //publication swiper
    if ($('.cms-page-module.blog-module').length) {
        new Swiper('.cms-page-module.blog-module .swiper', {
            roundLengths: true,
            setWrapperSize: true,
            cssWidthAndHeight: true,
            slidesPerView: 1.6,
            visibilityFullFit: true,
            autoResize: false,
            spaceBetween: 36,
            navigation: {
                nextEl: '.cms-blog-button-next',
                prevEl: '.cms-blog-button-prev',
            },
            breakpoints: {
                1690: {
                    slidesPerView: 3,
                },
                1440: {
                    slidesPerView: 2.6,
                },
                1300: {
                    slidesPerView: 2.4,
                },
                1160: {
                    slidesPerView: 2.2,
                },
                1030: {
                    slidesPerView: 2,
                },
            },
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        })
    }

    /****** PAGES MARQUES SWIPERS ******/

    if ($('.product_actif.swiper').length) {
        var swiperTopBrand = new Swiper('.product_actif.swiper', {
            freeMode: true,
            slidesPerView: "auto",
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        })
    }

    if ($('.marques_nav.swiper').length) {
        var swiperMarquesNav = new Swiper('.marques_nav.swiper', {
            freeMode: true,
            slidesPerView: "auto",
            spaceBetween: 6,
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        })
    }

    if ($('.marque_gondole.swiper').length) {
        var swiperMarque = new Swiper(".marque_gondole.swiper", {
            roundLengths: true,
            setWrapperSize: true,
            slidesPerView: 2.6,
            spaceBetween: 30,

            breakpoints: {
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1550: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
            navigation: {
                nextEl: '.assocBrand-button-next',
                prevEl: '.assocBrand-button-prev',
            },
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        });
    }

    /*** FICHE PRODUIT ***/
    /** Ouverture Fermeture Onglet Informations */
    $(".product_detail_wrapper .product_detail_title").on("click", function () {
        proceedTabClick(this);
    });

    setTimeout(() => {
        if ($('#gondole_aimerez').length) {
            var swiperAssociations = new Swiper('#gondole_aimerez', {
                slidesPerView: 2,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.associations-button-next',
                    prevEl: '.associations-button-prev',
                },
                breakpoints: {
                    1060: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1550: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    }
                },
                on: {
                    init: function () {
                        decodeVisibleSlides(this);
                    },
                    slideChange: function () {
                        decodeVisibleSlides(this);
                    }
                }
            });

            var slideCount = swiperAssociations.slides.length;

            $('#gondole_aimerez').addClass('slides-' + slideCount);
        }
    }, 500);

    if ($('.associated-product-lightbox').length) {
        var swiperAssociations = new Swiper('.associated-product-lightbox', {
            slidesPerView: "auto",
            spaceBetween: 21,
            pagination: {
                el: '.associated-product-lightbox-pagination',
                type: 'bullets',
            },
            navigation: {
                nextEl: '.associations-lightbox-button-next',
                prevEl: '.associations-lightbox-button-prev',
            },
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        });
    }

    let isDiffuseur = ($('#is_diffuseur').length) ? $('#is_diffuseur').val() : 0;
    let isCoffret = ($('#is_coffret').length) ? $('#is_coffret').val() : 0;

    if (isDiffuseur != 1 && isCoffret != 1) {
        if ($('.product_page #ligne_pointure').length) {
            $('#ligne_pointure').insertBefore($('.description_courte'));
            $('#ligne_pointure').addClass('visible');
        }
    }

    /****** CART ASSOCIATION SWIPER ******/

    if ($('body.step_1 .wrapperCartAssociations').length) {
        var swiperAssociations = new Swiper('.wrapperCartAssociations #cartAssociations', {
            roundLengths: true,
            setWrapperSize: true,
            slidesPerView: "auto",
            spaceBetween: 30,
            navigation: {
                nextEl: '.assoc-button-next.slide_next',
                prevEl: '.assoc-button-prev.slide_prev',
            },
            on: {
                init: function () {
                    decodeVisibleSlides(this);
                },
                slideChange: function () {
                    decodeVisibleSlides(this);
                }
            }
        });
    }

    getWishlistProducts();

    function handleBankSelection() {
        $(".wrapper_bloc_banque").on("click", function () {

            // On grise les autres
            $(".wrapper_bloc_banque").not($(this)).removeClass("actif");

            if (!$('.gift_card').hasClass('actif')) {
                // Si 'gift_card' était actif mais ne l'est plus, on déclenche le clic
                $('#gifCardInvisibleInput').click();
            }

            // On active la courrante
            $(this).addClass("actif");

            if (!$(this).hasClass("facilipay") && !$(this).hasClass("cofidis3x") && $("#recapAdresse").is(":visible")) {
                $("#recapAdresse").slideUp();
            } else if (($(this).hasClass("facilipay") || $(this).hasClass("cofidis3x")) && !$("#recapAdresse").is(":visible")) {
                $("#recapAdresse").slideDown();
            }

            if (!$(this).hasClass("credit_card") && !$(this).hasClass("gift_card") && !$(this).hasClass("facilipay") && !$(this).hasClass("cofidis3x") && !$(this).hasClass("alias_list_wrapper") && !$(this).hasClass("bloc_virement") && !$(this).hasClass("bloc_paid_by_link_hipay") && !$(this).hasClass("payment_in_store")) {
                $("form", this).submit();
            }
        });
    }

    handleBankSelection();

    $(document).on('click', '.bloc_add_alert_confirmation .close_bloc_add_alert_confirmation', function() {
        var wrapper_product = $(this).parents('.wrapperProdVertical');
        var wrapper_product_itm;

        if (wrapper_product.attr('data-prod') && wrapper_product.attr('data-prod').trim() !== '') {
            wrapper_product_itm = wrapper_product.attr('data-prod');
        } else if (wrapper_product.attr('data-produit-id') && wrapper_product.attr('data-produit-id').trim() !== '') {
            wrapper_product_itm = wrapper_product.attr('data-produit-id');
        } else {
            wrapper_product_itm = wrapper_product.attr('data-id');
        }

        $(this).parent().slideUp();
        wrapper_product.find('.container_achat_express .bloc_add_color:not(:has(button[onclick^="achatExpressV2Batch"])').slideDown().removeClass('loading');
        wrapper_product.find('.container_achat_express #bloc_alert_stock_' + wrapper_product_itm).css('display', 'flex');
        wrapper_product.find('.bloc_add_alert_form, .alert_stock').slideDown();
        wrapper_product.find('#bloc_add_alert_' + wrapper_product_itm).slideUp();

        if (wrapper_product.find('.formBatch').hasClass('open')) {
            wrapper_product.find('.formBatch').removeClass('open').slideUp();
        }
    });

    $('.satellite_politique_de_confidentialite .content_sat .cookieShowLightbox').click(function() {
        $('.satellite_politique_de_confidentialite #cookiesLightbox').addClass('displayCookies');
        if($('.satellite_politique_de_confidentialite #cookiesLightbox').has('.hideCookies')) {
            $('.satellite_politique_de_confidentialite #cookiesLightbox').removeClass('hideCookies');
        }
        $('.satellite_politique_de_confidentialite #cookiesLightbox .w-form-line.w-submit button.w-loader').addClass('hideLoader');
    });

    $('.satellite_politique_de_confidentialite #js_cookie_refuse, .satellite_politique_de_confidentialite #js_cookie_accept').click(function() {
        if($('.satellite_politique_de_confidentialite #cookiesLightbox').has('.displayCookies')) {
            setTimeout(() => {
                $('.satellite_politique_de_confidentialite #cookiesLightbox').removeClass('displayCookies');
                $('.satellite_politique_de_confidentialite #cookiesLightbox').addClass('hideCookies');
                $('.satellite_politique_de_confidentialite #shadCookie').removeClass('actif');
            }, 500);
        }
    });

    if ($('.pushPromoBasket').length) {
        if ($('#tunnel_right_col .pushBasketWrapper').length) {
            $('#tunnel_right_col .pushBasketWrapper').hide();
        }
    }

    // SW-19561 - handle #search=??? in home module
    document.querySelectorAll('.home-module-body a[href*="#search="]').forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            // Gets the href attribute
            const href = link.getAttribute("href");

            // Extracts the search value from the hash
            const match = href.match(/#search=([^&]+)/);

            if (match && match[1]) {
                const searchValue = match[1]; // ex : "sergent%20major"

                // Starts a search with the extracted value
                if (!window.wShop) {
                    console.error("wShop is not defined.");
                    return;
                }

                window.wShop.searchStr = searchValue;
                // Add also the search value in the search input if exists
                try {
                    $("#search_home").val(decodeURIComponent(searchValue));
                    applySearchClass();
                } catch (e) {
                    console.error("Error setting search input value:", e);
                }
                window.wShop.getProducts();
                document.addEventListener("search_getProducts_end", function () {
                    applySearchClass();
                }, { once: true });
            }
        });
    });

    $(document).on('click', '#retour_product .btn_retour, #cms_page_btn_back .itm_back_btn', handleSmartBack);
});

document.addEventListener('DOMContentLoaded', function() {
    if ($('.product_page #site_global_wrap').length) {
        const pageProduit = document.querySelector('.page_wrapper');

        if (pageProduit && !pageProduit.classList.contains('page_loaded')) {
            pageProduit.classList.add('page_loaded');
        }
    }
});

function swiperTG() {
    if ($('#swiperTg').length) {
        if ($('#block_news').length) {
            new Swiper('#swiperTg.swiper', {
                roundLengths: true,
                setWrapperSize: true,
                slidesPerView: 2.6,
                spaceBetween: 30,
                breakpoints: {
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1550: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                },
                navigation: {
                    nextEl: '.swiperTg-button-next',
                    prevEl: '.swiperTg-button-prev',
                },
                on: {
                    init: function () {
                        decodeVisibleSlides(this);
                    },
                    slideChange: function () {
                        decodeVisibleSlides(this);
                    }
                }
            })
        } else {
            new Swiper('#swiperTg.swiper', {
                roundLengths: true,
                setWrapperSize: true,
                slidesPerView: 2.6,
                spaceBetween: 30,
                grid: {
                    rows: 1,
                    fill: 'row',
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                        grid: {
                            rows: 2,
                        },
                    },
                    1550: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        grid: {
                            rows: 2,
                        },
                    },
                },
                pagination: {
                    el: '#swiperTg .swiper-pagination',
                },
                on: {
                    init: function () {
                        decodeVisibleSlides(this);
                    },
                    slideChange: function () {
                        decodeVisibleSlides(this);
                    }
                }
            })
        }
    }
}

$(document).ready(function() {
    var oneSizeNone = $('.shoesize:contains("TAILLE UNIQUE"), .sub_taille:contains("TAILLE UNIQUE")');

    if (oneSizeNone.length) {
        oneSizeNone.hide();
    }
});

/**
 * Initializes the product fieldset by simulating the behavior of a select element.
 *
 * @param {string} id - The ID of the element to initialize.
 *
 * This function adds the "opened" class to the element with the given ID and the "actif" class to the element with the ID "shad".
 * It also sets up an event listener on the "shad" element to remove these classes when it is clicked or touched.
 */
function initProductFieldset(id) {
    // Function to simulate the behavior of a select
    var listColorSize = $("#" + id + ".choices_list");
    var shadSelect = $("#shad");

    listColorSize.addClass("opened");
    shadSelect.addClass("actif");

    shadSelect.on("click touch", function () {
        listColorSize.removeClass("opened");
        $(this).removeClass("actif");
    });

    $("#color_list_wrapper .wrapper_select, #size_list_wrapper .wrapper_select").overlayScrollbars({});
}

/**
 * Simulates the behavior of a select element by closing the choices list and removing active states.
 *
 * @param {string} [id] - The ID of the element to target. If not provided, the function will target the currently opened choices list.
 */
function exitProductFieldset(id) {
    var shadSelect = $(".shad.actif");
    var listColorSize;
    if (id !== undefined) {
        /*  Function to simulate the behavior of a select */
        listColorSize= $("#" + id +".choices_list");
    } else{
        listColorSize= $(".choices_list.opened");
    }
    listColorSize.removeClass("opened");
    shadSelect.removeClass("actif");
}


/**
 * Call to get batch product based on selection
 **/
function onItemProdChange (prod_choice_id = '', choice_prod_type = '') {
    let choice1 = '';
    let choice2 = '';

    // Uncheck previous selection for coffret product
    if ($('.is_regroupement_reference.coffret').length) {
        $('.prod1').not(this).prop('checked', false);
    }

    //Get product_choice id for batchch distinct product
    if (choice_prod_type && prod_choice_id) {
        if ( choice_prod_type === 'prod1') {  // first choice product
            choice1 = $('input[name="prod_choice_'+prod_choice_id+'"]').val();
            choice2 = $('#prod2').val();
            if (choice1 == choice2) {
                let options = [];
                // Loop through each input with class 'prod1'
                $('input.prod2').each(function() {
                    options.push($(this).val());
                });
                choice2 = options[0];
            }
        }
        if (choice_prod_type === 'prod2') {  // second choice product
            choice1 = $('#prod1').val();
            choice2 = $('input[name="prod_choice_'+prod_choice_id+'"]').val();
            if (choice1 == choice2) {
                let options = [];
                // Loop through each input with class 'prod1'
                $('input.prod1').each(function() {
                    options.push($(this).val());
                });
                choice1 = options[0];
            }
        }
    }
    // get product batch based on selections from ajax call
    if (choice1 && choice2) {
        let data = {
            prod1: choice1,
            prod2: choice2,
            head_ref: $('input[name="head_ref"]').val(),
            json: 'json'
        };

        $.ajax({
            url: path_relative_root + 'ajax_distinct_batch_data.php',
            type: 'get',
            async: true,
            dataType: 'json',
            data: data,
            success: function (res) {
                if (res != undefined && res != '' && res != null){
                    // Get current URL
                    const currentUrl = window.location.href;
                    const id = res;
                    const regex = /-(\d+)\.html$/;
                    const newUrl = currentUrl.replace(regex, `-${id}.html`);
                    //redirect to selected bacth
                    window.location.href = newUrl;
                }
            }
        });
    }
}

function triggerFunctionOnSearchEnd() {
    setTimeout(() => {
        swiperTG();
    }, 200);
}

function proceedTabClick (element) {
    // Si on clique sur l'onglet ouvert => Fermeture de l'onglet
    if ($(element).parent().hasClass("actif")) {
        $(element).parent().removeClass("actif");
        $(element).siblings(".product_detail_content").removeClass("actif");

        // Si on clique sur un autre onglet => Fermeture des onglets ouverts et ouverture de l'onglet sélectionné
    } else {
        $(".product_detail").removeClass("actif");
        $(".product_detail_content").hide();
        $(element).parent().addClass("actif");
        $(element).siblings(".product_detail_content").slideDown();

        // scroll to the title which has been clicked
        var scrollOffset = $(element).offset().top - 200;
        $('html, body').animate({
            scrollTop: scrollOffset
        }, 500);
    }
}

function handleSmartBack(event) {
    event.preventDefault();

    var hasInternalHistory = false;

    if (window.history.length > 1 && document.referrer) {
        try {
            hasInternalHistory = new URL(document.referrer).origin === window.location.origin;
        } catch (error) {
            hasInternalHistory = false;
        }
    }

    if (hasInternalHistory) {
        window.history.back();
        return;
    }

    var target = event.currentTarget;
    var container = target.closest('#cms_page_btn_back, #retour_product');
    var fallbackUrl = '';

    if (target.hasAttribute('data-cms-url-back') || (container && container.id === 'cms_page_btn_back')) {
        var cmsUrlBack = target.getAttribute('data-cms-url-back');
        var parentUrl = target.getAttribute('data-cms-parent-url');
        fallbackUrl = cmsUrlBack || parentUrl;
    } else {
        var breadcrumbLinks = document.querySelectorAll('#breadcrumbs .breadcrumb a');
        var objectLevelLink = breadcrumbLinks[breadcrumbLinks.length - 1];
        if (objectLevelLink) {
            fallbackUrl = objectLevelLink.href;
        }
    }

    var homeUrl = typeof path_relative_root !== 'undefined' && path_relative_root
        ? path_relative_root
        : '/';

    window.location.assign(fallbackUrl || homeUrl);
}

function closeSizeNotAvailable(elem) {
    // Hide bloc alert stock
    $('#bloc_size_not_available_' + elem).hide();

    $('#ligne_couleur_' + elem).parent().show();
    // Show bloc colors
    $('#ligne_couleur_' + elem).show();
    $('.wishlistBtn').show();
    $('.bloc_add_color').show();
}
